interface IProps {
    width?: number;
    height?: number;
}

export const PlaylistIcon = (props: IProps) => {
    const {width, height} = props;
    return (<svg
            xmlns="http://www.w3.org/2000/svg"
            width={width || 16}
            height={height || 17}
            viewBox="0 0 16 17"
            fill="none"
        >
            <path d="M0 0.0195312H16V2.01953H0V0.0195312Z" fill="#FCFCFC"/>
            <path d="M0 14.0195H16V16.0195H0V14.0195Z" fill="#FCFCFC"/>
            <path d="M7 7.01953H16V9.01953H7V7.01953Z" fill="#FCFCFC"/>
            <path d="M0 5.01953V11.0195L5.2002 8.01953L0 5.01953Z" fill="#FCFCFC"/>
        </svg>
    );
}
